module.exports = __webpack_public_path__ + "static/media/performanceManagementBg.f77e8eab.svg";